import {React ,useState,useEffect} from "react";

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfilesList from "examples/Lists/ProfilesList";
import { Box, Drawer, AppBar,ListItemAvatar, Avatar,Toolbar, Typography, TextField, Button, Paper, List, ListItem, ListItemText } from "@mui/material";
import ChatList from "./components/chatlist";
import ChatHistory from "./components/chathistory";
import MessageForm from "./components/messageform";
import socket from "config/socket.io";

import {
  Get_Chat_detail,Get_Chats
} from "context";


const drawerWidth = 240;



function Chat() {
  
 const notificationSound = new Audio("data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YQAAAIAAAACAgICAgICAgP8AAAAA/wD/AP//AAD//wD/AP8A/wAAAAD/AP8AAAAA");

  // const messages = [
  //   { sender: "John", text: "Hello! How are you?", time: "10:00 AM" },
  //   { sender: "You", text: "I'm good, thanks! How about you?", time: "10:01 AM" },
  //   { sender: "John", text: "Great to hear!", time: "10:02 AM" },
  // ];
  

  const [profiles, setprofiles] = useState([]); 
  const [messages, setmessages] = useState([]); 
  const [selectedChat , setselectedChat] = useState(0);
  // const [audioUnlocked, setAudioUnlocked] = useState(false);
  useEffect(()=>{
    socket.on('NewChat', (profile) => {
      setprofiles((prevprofiles) => [...prevprofiles, profile]);
      notificationSound.play();
    });
    socket.on('client_message', (message) => {
      setmessages((prevmessages) => [...prevmessages, message]);
      notificationSound.play();
    });
    socket.on('org_message', (message) => {
      setmessages((prevmessages) => [...prevmessages, message]);
    });
    fetchChats();
  },[]); 
  const fetchChats = async () => {
    const resp = await Get_Chats();
    setprofiles(resp);
  }
  const handleProfileClick = async (profile) => {
    
    const resp = await Get_Chat_detail(profile.id);
    setselectedChat(profile.id);
    setmessages(resp.ChatDetails);
    // Handle navigation, API calls, or state updates here
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} sx={{ minHeight: '80vh' }}>
        <Grid container spacing={3}>
          <Grid item xs={3} md={3} lg={3}>
            <MDBox >
              <ChatList profiles={profiles} handleProfileClick={handleProfileClick}/>
            </MDBox>
          </Grid>
          <Grid item xs={9} md={9} lg={9}>
           
                 {selectedChat ? (
                   <MDBox >
                     <ChatHistory messages={messages}/>
                     <MessageForm selectedChatID={selectedChat} />
                  </MDBox>
                ) : (
                  <MDBox sx={{ textAlign: 'center', py: 2, color: 'gray' }}>
                    Select a chat to start messaging.
                  </MDBox>
                  )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Chat;
